module.exports = __webpack_public_path__ + "img/radio_checked.3510f8f4.png";